import React from "react";
import {observer} from "mobx-react";
import IconButton from '../../comum/components/IconButton'
import moment from 'moment'
import {ExcelExport, ExcelExportColumn} from "@progress/kendo-react-excel-export";

@observer
export default class ExportarExcelAnalise extends React.Component {
    constructor(props) {
        super(props);
        this.controller = this.props.controller;
    }

    _exporter;
    export = () => {
        this._exporter.save();
    };

    render() {
        let lista = [];
        if(this.controller.getLista().length > 0){ lista = this.controller.getListaCopia(); } else { lista = []; }
        let desabilita;
        if(lista.length > 0){
            desabilita=false;
        }else{
            desabilita=true;
        }

        if(lista.length > 0){
            lista.map(data => {
                const keys = Object.keys(data);
                keys.map(key =>{
                    if(key.includes('Format') && moment(data[key.replace('Format','')]).format("DD/MM/YYYY HH:mm") !== 'Invalid date')
                        data[key.replace('Format','')] = moment(data[key.replace('Format','')]).format("DD/MM/YYYY HH:mm")
                })
            })
        }

        let cols = this.controller.colunasExportacao;
        return (
            <div>
                <IconButton icon="file-excel"
                            text="Baixar XLS"
                            size="md"
                            disabled={desabilita}
                            onClick={!desabilita ? this.export : () => {}}
                />
                <ExcelExport
                    data={lista}
                    fileName="AnaliseCritica.xlsx"
                    ref={(exporter) => { this._exporter = exporter; }} >
                    { cols.map((coluna, x) => (
                        <ExcelExportColumn
                            key={x}
                            title={coluna.text}
                            field={coluna.dataField}
                        />))
                    }
                </ExcelExport>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/analise/components/ExportarExcelAnalise.js